module.exports = __webpack_public_path__ + "img/sidebar-2.32103624.jpg";